import React from "react";

const Terms = () => {
  return (
    <div>
      <h3 className="bg-light-black p-4 font-bold m-4 rounded-xl">
        Terms of Use
      </h3>
      <p className="text-white text-sm mx-36 mt-6">
        Last Updated: [Date] <br /> Welcome to MixxAI! These Terms of Use govern
        your use of the MixxAI application and any related services provided by
        [Your Company Name].
        <br /> By accessing or using MixxAI, you agree to abide by these Terms
        of Use and the Privacy Policy.
        <br /> 1. Service Description: MixxAI is a messaging application built
        on OpenAI's ChatGPT technology, offering users the ability to engage in
        AI-powered conversations.
        <br /> 2. Acceptable Use: You agree not to use MixxAI in a way that:
        Violates any laws or regulations. Infringes on the rights of others.
        Distributes harmful or offensive content.
        <br /> 3. User Accounts: Users may need to register for an account to
        access certain features. You are responsible for maintaining the
        confidentiality of your account information.
        <br /> 4. Intellectual Property: All rights, title, and interest in and
        to MixxAI are and will remain the exclusive property of [Your Company
        Name] and its licensors.
        <br /> 5. User Content: Users are responsible for their conduct and any
        content they submit to MixxAI. We may review and remove any content that
        violates these Terms or our policies.
        <br /> 6. Privacy: Your use of MixxAI is subject to our Privacy Policy,
        which explains how we collect, use, and protect your personal
        information.
        <br /> 7. Modifications to Service: [Your Company Name] reserves the
        right to modify or discontinue, temporarily or permanently, the service
        (or any part thereof) with or without notice.
        <br /> 8. Disclaimers: MixxAI is provided on an "as is" and "as
        available" basis. [Your Company Name] does not guarantee that the app
        will be uninterrupted or error-free.
        <br /> 9. Limitation of Liability: [Your Company Name] shall not be
        liable for any indirect, incidental, special, consequential, or punitive
        damages arising out of or in connection with your use of MixxAI.
        <br /> 10. Governing Law: These Terms shall be governed by the laws of
        [Your Jurisdiction].
        <br /> 11. Changes to Terms: We reserve the right to modify these Terms
        at any time. We will notify users of any changes by updating the date at
        the top of these terms.
        <br /> 12. Contact Us: If you have any questions about these Terms,
        please contact us at [Your Contact Information].
      </p>
    </div>
  );
};

export default Terms;
